import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'
import type { ChatPromptId, ChatId } from '../../../shared/domain/aiChats/types.no-deps'

export const route: Route = { method: 'PUT', pattern: '/api/ai-chats/:chatId/prompts/:promptId/feedback' }

type Params = { chatId: ChatId; promptId: ChatPromptId }
type Body = { isGood?: boolean; note: string }
type Query = never
type Output = never

export type UpdateAiPromptFeedbackEndpoint = Endpoint<Params, Body, Query, Output>

export const updateAiPromptFeedbackRequest = (request: Request, args: RequestArgs<UpdateAiPromptFeedbackEndpoint>) =>
    request<UpdateAiPromptFeedbackEndpoint>(route, args)
